module.exports = __webpack_public_path__ + "static/media/Olivia Kitchen (9).76b07e96.jpg";